module.exports = __webpack_public_path__ + "static/media/Griffin451_3c.2888f42d.svg";